// =========================================================
// PAGINATION (Global Kapsama Çıkartıldı)
// =========================================================
window.shopGoToPage = function(pageNum) {
    var input = document.getElementById('shop_page_num');
    if (input) {
        input.value = pageNum;
        var form = document.getElementById('shop-filter-form');
        if (form) form.submit();
    }
};

// =========================================================
// FİYAT SLIDER & SENKRONİZASYON
// =========================================================
(function () {
    var instances = {};
    var globalMin = 0; // Varsayılan değerler
    var globalMax = 1000;

    function buildInstance(id) {
        var rangeMin = document.getElementById('min-price-range-' + id);
        var rangeMax = document.getElementById('max-price-range-' + id);
        var inputMin = document.getElementById('min_price_input-' + id);
        var inputMax = document.getElementById('max_price_input-' + id);
        var textMin  = document.getElementById('min-price-text-' + id);
        var textMax  = document.getElementById('max-price-text-' + id);
        var fill     = document.getElementById('price-slider-fill-' + id);
        var thumbMin = document.getElementById('thumb-min-' + id);
        var thumbMax = document.getElementById('thumb-max-' + id);
        var valMin   = document.querySelector('.price-min-val[data-instance="' + id + '"]');
        var valMax   = document.querySelector('.price-max-val[data-instance="' + id + '"]');
        
        if (!rangeMin || !rangeMax) return null;
        return { rangeMin, rangeMax, inputMin, inputMax, textMin, textMax, fill, thumbMin, thumbMax, valMin, valMax };
    }

    function renderInstance(inst, min, max) {
        var range = globalMax - globalMin;
        if (range <= 0) range = 1; // 0'a bölünme hatasını engellemek için
        
        var pMin  = ((min - globalMin) / range) * 100;
        var pMax  = ((max - globalMin) / range) * 100;
        
        if (inst.fill)     { inst.fill.style.left = pMin + '%'; inst.fill.style.width = (pMax - pMin) + '%'; }
        if (inst.thumbMin) inst.thumbMin.style.left = pMin + '%';
        if (inst.thumbMax) inst.thumbMax.style.left = pMax + '%';
        if (inst.valMin)   inst.valMin.textContent = Math.round(min);
        if (inst.valMax)   inst.valMax.textContent = Math.round(max);
        if (inst.rangeMin) inst.rangeMin.value = min;
        if (inst.rangeMax) inst.rangeMax.value = max;
        if (inst.inputMin) inst.inputMin.value = Math.round(min);
        if (inst.inputMax) inst.inputMax.value = Math.round(max);
        if (inst.textMin)  inst.textMin.value = Math.round(min);
        if (inst.textMax)  inst.textMax.value = Math.round(max);
    }

    function syncAll(min, max) {
        Object.keys(instances).forEach(function (id) {
            renderInstance(instances[id], min, max);
        });
    }

    function getMinMax(id) {
        return {
            min: parseFloat(instances[id].rangeMin.value),
            max: parseFloat(instances[id].rangeMax.value)
        };
    }

    function initInstance(id, container) {
        // PHP'den gelen global sınırları HTML üzerinden oku
        globalMin = parseFloat(container.dataset.globalMin) || 0;
        globalMax = parseFloat(container.dataset.globalMax) || 1000;

        var inst = buildInstance(id);
        if (!inst) return;
        instances[id] = inst;

        inst.rangeMin.addEventListener('input', function () {
            var v = getMinMax(id);
            if (v.min > v.max - 1) { inst.rangeMin.value = v.max - 1; v.min = v.max - 1; }
            syncAll(v.min, v.max);
        });
        inst.rangeMax.addEventListener('input', function () {
            var v = getMinMax(id);
            if (v.max < v.min + 1) { inst.rangeMax.value = v.min + 1; v.max = v.min + 1; }
            syncAll(v.min, v.max);
        });
        if (inst.textMin) {
            inst.textMin.addEventListener('change', function () {
                var val = Math.max(globalMin, Math.min(parseFloat(this.value) || globalMin, globalMax));
                syncAll(val, getMinMax(id).max);
            });
        }
        if (inst.textMax) {
            inst.textMax.addEventListener('change', function () {
                var val = Math.max(globalMin, Math.min(parseFloat(this.value) || globalMax, globalMax));
                syncAll(getMinMax(id).min, val);
            });
        }
        renderInstance(inst, parseFloat(inst.rangeMin.value), parseFloat(inst.rangeMax.value));
    }

    // CHECKBOX SENKRONIZASYONU
    document.addEventListener('change', function (e) {
        var input = e.target;
        if (!input.classList.contains('filter-sync-input')) return;

        var syncKey = input.dataset.sync;

        if (input.hasAttribute('data-toggle-exclusive') && input.checked) {
            var group = input.closest('[data-toggle-group]');
            if (group) {
                group.querySelectorAll('[data-toggle-exclusive]').forEach(function(toggle) {
                    if (toggle !== input) {
                        toggle.checked = false;
                    }
                });
            }
            var otherGroupName = syncKey === 'on_sale' ? 'best_seller' : 'on_sale';
            document.querySelectorAll('[data-sync="' + otherGroupName + '"]').forEach(function(other) {
                other.checked = false;
            });
        }

        document.querySelectorAll('[data-sync="' + syncKey + '"]').forEach(function (other) {
            if (other !== input) {
                if (syncKey === 'product_tag') {
                    if (other.value === input.value) other.checked = input.checked;
                } else {
                    other.checked = input.checked;
                }
            }
        });

        var form = document.getElementById('shop-filter-form');
        if (form) form.submit();
    });

    // Sayfa Yüklendiğinde Başlatıcı
    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('[data-filter-instance]').forEach(function (el) {
            initInstance(el.dataset.filterInstance, el);
        });
    });
})();

// =========================================================
// BIRBIRINI DIŞLAYAN TOGGLELER
// =========================================================
(function() {
    document.addEventListener('change', function(e) {
        var input = e.target;
        if (!input.hasAttribute('data-toggle-exclusive')) return;
        
        var group = input.closest('[data-toggle-group]')?.getAttribute('data-toggle-group');
        if (!group) return;
        
        var allToggles = document.querySelectorAll('[data-toggle-group="' + group + '"] [data-toggle-exclusive]');
        
        if (input.checked) {
            allToggles.forEach(function(toggle) {
                if (toggle !== input) {
                    toggle.checked = false;
                }
            });
        }
        
        var form = document.getElementById('shop-filter-form');
        if (form) form.submit();
    });
})();